export var createWakeLock = function createWakeLock(emitNotSupportedError, window, wrapSubscribeFunction) {
  return function (type) {
    return wrapSubscribeFunction(function (observer) {
      if (window === null || window.navigator === undefined || window.navigator.wakeLock === undefined) {
        return emitNotSupportedError(observer);
      }

      var releaseWakeLock = function releaseWakeLock(wakeLockSentinel) {
        return wakeLockSentinel.release().catch(function () {// Ignore errors.
        });
      };

      var removeReleaseEventListener = function removeReleaseEventListener(wakeLockSentinel) {
        wakeLockSentinel.onrelease = null;
      };

      var isActive = true;

      var unsubscribeWhileRequesting = function unsubscribeWhileRequesting() {
        isActive = false;
      };

      var unsubscribe = unsubscribeWhileRequesting;

      var requestWakeLock = function requestWakeLock() {
        return window.navigator.wakeLock.request(type).then(function (wakeLockSentinel) {
          if (isActive) {
            observer.next(true);
          }

          if (isActive) {
            wakeLockSentinel.onrelease = function () {
              observer.next(false);
              unsubscribe = unsubscribeWhileRequesting;
              removeReleaseEventListener(wakeLockSentinel);
              requestWakeLock();
            };

            unsubscribe = function unsubscribe() {
              removeReleaseEventListener(wakeLockSentinel);
              releaseWakeLock(wakeLockSentinel);
            };
          } else {
            releaseWakeLock(wakeLockSentinel);
          }
        }, function (err) {
          if (isActive) {
            observer.error(err);
          }
        });
      };

      requestWakeLock();
      return function () {
        return unsubscribe();
      };
    });
  };
};